var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"export-data-options":_vm.exportDataOptions,"show-single-actions":false},on:{"filterChange":_vm.onListFilterChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }